<template>
  <popup
    :opened="dataToShow"
    @close="close"
  >
    <!-- BEGIN Content modal add referent -->
    <div v-if="dataToShow">
      <div class="my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15">
        <h3
          v-if="formationToEdit === null"
          class="mb-10"
        >
          Ajouter une nouvelle formation
        </h3>
        <h3
          v-if="formationToEdit"
          class="mb-10"
        >
          Modifier la formation
        </h3>
        <div class="grid grid-cols-4 gap-5 items-center">
          <input-text
            :error="true"
            :maxlength="40"
            :value="newFormation.intitule_parcours"
            class="lg:col-span-2"
            libelle="Diplôme et titre obtenu"
            name="intitule_parcours"
            @input="(newValue) => {newFormation.intitule_parcours = newValue}"
          />
          <date-picker
            :value="newFormation.debut_parcours"
            class="col-span-full md:col-span-1"
            format="dd/MM/yyyy"
            initialview="year"
            libelle="Début"
            name="debut_parcours"
            @input="(newValue) => {newFormation.debut_parcours = newValue}"
          />
          <date-picker
            :value="newFormation.fin_parcours"
            class="col-span-full md:col-span-1"
            format="dd/MM/yyyy"
            initialview="year"
            libelle="Fin"
            name="fin_parcours"
            @input="(newValue) => {newFormation.fin_parcours = newValue}"
          />
          <input-text
            :error="true"
            :value="newFormation.localisation_parcours"
            class="md:col-span-2"
            libelle="Ville"
            name="localisation_parcours"
            @input="(newValue) => {newFormation.localisation_parcours = newValue}"
          />
          <input-select
            :datas="[
              {value: 'Aucun'},
              {value: 'Niveau 3 - CAP, BEP'},
              {value: 'Niveau 4 - Baccalauréat'},
              {value: 'Niveau 5 - DEUG, BTS, DUT, DEUST'},
              {value: 'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1'},
              {value: 'Niveau 7 - Master, diplôme d\'études approfondies, diplôme d\'études supérieures spécialisées, diplôme d\'ingénieur'},
              {value: 'Niveau 8 - Doctorat, habilitation à diriger des recherches'},
              {value: 'Autre'},
            ]"
            :value="newFormation.niveau_cursus"
            class="md:col-span-2"
            libelle="Niveau de formation"
            name="niveau_cursus"
            @input="(newValue) => {newFormation.niveau_cursus = newValue}"
          />
          <input-select
            :datas="[
              {value: 'Jamais scolarisé(e)'},
              {value: 'Scolarisé(e) en Etablissement Médico Social (IME-IMPRO, ITEP...)'},
              {value: 'Collège (Classe ordinaire)'},
              {value: 'Collège UPI'},
              {value: 'Lycée (Classe ordinaire)'},
              {value: 'Lycée UPI'},
              {value: 'Enseignement technique ou professionnel court (CAP, BEP etc...)'},
              {value: 'Enseignement technique ou professionnel long (Brevet pro, Bac pro etc...)'},
              {value: 'Universités ou études supérieures'},
              {value: 'Non précisé'},
            ]"
            :value="newFormation.etablissement_cursus"
            class="md:col-span-2"
            libelle="Type d'établissement"
            name="etablissement_cursus"
            @input="(newValue) => {newFormation.etablissement_cursus = newValue}"
          />
        </div>

        <div class="flex justify-center mt-15">
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="ENREGISTRER"
            type-shadow="shadow-pink"
            @clickAction="(formationToEdit) ? modifyFormation() : addFormation()"
          />
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from './../../../components/Popup.vue';
import Icon from  './../../../components/Icon.vue';
import InputText from './../../../components/Inputs/InputText.vue';
import InputSelect from './../../../components/Inputs/InputSelect.vue';
import DatePicker from './../../../components/Inputs/DatePicker.vue';
import ActionButton from './../../../components/ActionButton.vue';

const emptyFormation = () => ({
  intitule_parcours:'',
  debut_parcours:'',
  fin_parcours:'',
  localisation_parcours:'',
  niveau_cursus:'',
  etablissement_cursus:''
});

export default {
  components:{
    Popup,
    Icon,
    InputText,
    InputSelect,
    DatePicker,
    ActionButton,
  },

  props:{
    dataToShow:{
      type: Boolean,
      required: false,
      default: false
    },
    formationToEdit:{
      type: Object,
      required: false,
      default: null
    }
  },

  data(){
    return {
      newFormation: emptyFormation(),
    };
  },

  methods:{
    close(){
      this.resetForm();

      this.$emit('close');
    },

    resetForm(){
      this.newFormation = emptyFormation();
    },

    addFormation(){
      this.$emit('addFormation', this.newFormation);
      this.close(false);
    },

    modifyFormation(){
      this.$emit('modifyFormation', this.newFormation);
      this.close(false);
    },
  },
  watch:{
    dataToShow:{
      handler(){
        if(this.formationToEdit){
          this.newFormation = this.formationToEdit.value.value;
          return;
        }
        this.resetForm();
      },
    },
  }
};
</script>
